<template>
<vueMain :title="$t('design.title')">
  <div class="card">
    <div class="container-fluid">
      <div class="row">
        <nav class="col-lg-2 pl-0 pr-0 sidebar hover-bg">
          <ul class="nav-pills nav flex-column">
            <li class="nav-item" @click="setActive('typography')">
              <span class="nav-link" :class="{ active: isActive('typography') }">{{ $t("design.typography") }}</span>
            </li>
            <li class="nav-item" @click="setActive('colors')">
              <span class="nav-link" :class="{ active: isActive('colors') }">{{ $t("design.colors") }}</span>
            </li>
            <li class="nav-item" @click="setActive('forms')">
              <span class="nav-link" :class="{ active: isActive('forms') }">{{ $t("design.forms") }}</span>
            </li>
          </ul>
        </nav>
        <div class="col-lg-10 pr-0">
          <typography v-if="activeItem == 'typography'"></typography>
          <colors  v-if="activeItem == 'colors'"></colors>
          <forms  v-if="activeItem == 'forms'"></forms>
        </div>
      </div>
    </div>
  </div>
</vueMain>
</template>
<style lang="scss" scoped="true">
  .nav-link {
    cursor: pointer;
  }
</style>
<script>
import colors from '@/components/Pages/Styles/Colors.vue';
import forms from '@/components/Pages/Styles/Forms.vue';
import typography from '@/components/Pages/Styles/Typography.vue';
import vueMain from '@/components/Layout/Main.vue';

export default {
  name: 'Settings',
  components: {
    typography,
    colors,
    forms,
    vueMain
  },
  data: function () {
    return {
      activeItem: 'typography'
    };
  },
  methods: {
    isActive: function (menuItem) {
      return this.activeItem === menuItem;
    },
    setActive: function (menuItem) {
      this.activeItem = menuItem;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/Styles/Index.vue